import {
    appModuleIds,
    stepsListIndexes,
    ZOOM_HIERARCHY_MIN_LEVEL,
} from '@/shared/constants'

function flyEvent(this: any, district) {
    if (!district.envelope) {
        this.$map.jumpTo({
            center: district.geometry,
            zoom: ZOOM_HIERARCHY_MIN_LEVEL[
                stepsListIndexes.districtInfoStepIndex
            ],
        })
        return
    }

    this.$map.fitBounds(district.envelope, {
        speed: 20,
        // zoom: 8,
        // padding: {
        //     right: 700,
        // },
        duration: 0,
    })
}

export default function (this: any, district) {
    // this.$dispatch('setStepActiveId', stepsListIndexes.districtInfoStepIndex)
    console.log('handle district', district.id)

    if (!district.geometry) return
    // const regionBbox: BBox = bbox(region.geometry)
    // this.$map.fitBounds(regionBbox)

    console.log('district.code', district.id)
    this.$state.view.districtsView.chosenDistrict.id = district.id
    this.$state.view.districtsView.chosenDistrict.geometry = district.geometry
    this.$state.view.districtsView.chosenDistrict.bbox = district.envelope

    // this.$state.chosenAppModule.id !== appModuleIds.gasificationPlan &&
    //     this.$dispatch(
    //         'setStepActiveId',
    //         stepsListIndexes.districtInfoStepIndex
    //     )

    this.$dispatch('setStepActiveId', stepsListIndexes.districtInfoStepIndex)
    flyEvent.call(this, district)
}
